import { useContext } from "react"
import { EditorToolbarTextDropdown, EditorToolbarTextDropdownOption, EditorToolbarTray } from "./EditorToolbarUI";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorHeadingTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarTextDropdown
                defaultIcon={<MaterialIcon name='h_mobiledata' weight={300}/>}
                defaultValue={'paragraph'}
                defaultName={'Normal tekst'}
                onChange={(value) => {
                    if(value === 'h1') editor.commands.setHeading({ level: 1 });
                    else if(value === 'h2') editor.commands.setHeading({ level: 2 });
                    else if(value === 'h3') editor.commands.setHeading({ level: 3 });
                    else if(value === 'h4') editor.commands.setHeading({ level: 4 });
                    else if(value === 'paragraph') editor.chain().focus().setParagraph().run();
                }}
                selectedValue={editorState.headingLevel}
            >
                <EditorToolbarTextDropdownOption
                    icon={<MaterialIcon name='h_mobiledata' weight={300}/>}
                    name='Normal tekst'
                    value={'paragraph'}
                />
                <EditorToolbarTextDropdownOption
                    icon={<MaterialIcon name='format_h1' weight={300}/>}
                    name='Overskrift 1'
                    value={'h1'}
                />
                <EditorToolbarTextDropdownOption
                    icon={<MaterialIcon name='format_h2' weight={300}/>}
                    name='Overskrift 2'
                    value={'h2'}
                />
                <EditorToolbarTextDropdownOption
                    icon={<MaterialIcon name='format_h3' weight={300}/>}
                    name='Overskrift 3'
                    value={'h3'}
                />
                <EditorToolbarTextDropdownOption
                    icon={<MaterialIcon name='format_h4' weight={300}/>}
                    name='Overskrift 4'
                    value={'h4'}
                />
            </EditorToolbarTextDropdown>
        </EditorToolbarTray>
    )
}





                    